const normalizeBaseUrl = (value = "") => value.trim().replace(/\/+$/, "");

export const API_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_API_URL);
export const PUBLIC_BASE_URL = normalizeBaseUrl(process.env.PUBLIC_URL || "");

export const withPublicUrl = (path = "") => {
  if (!path) {
    return PUBLIC_BASE_URL || "/";
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${PUBLIC_BASE_URL}${normalizedPath}`;
};
